module.exports = __webpack_public_path__ + "static/media/cms.4816f426.webp";